import './../styles/home/home.scss';
import './home/main-services';
import './home/posts-carousel';

export default {
  init() {
    console.log('strona główna');
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  }
};
